<template><div v-if="event"><CultureNav /><ReckonBallPage :event="event" /><AppFooter /></div><div v-else class="not-found"><v-container><h1>Reckon Ball year not found</h1><v-btn :to="{ name: 'reckon-ball-archive' }">View Reckon Ball</v-btn></v-container></div></template>
<script>
import AppFooter from '@/components/Footer.vue';
import CultureNav from '@/components/reckon-way/culture/CultureNav.vue';
import ReckonBallPage from '@/components/reckon-way/reckon-ball/ReckonBallPage.vue';
import { reckonBallByYear } from '@/content/reckon-ball';

export default {
  name: 'ReckonBallYearView',
  components: {
    AppFooter, CultureNav, ReckonBallPage,
  },
  computed: { event() { return reckonBallByYear[this.$route.params.year]; } },
};
</script>
<style scoped>.not-found{background:#050505;color:#fff;min-height:100vh;padding-top:50px}</style>
